import React, { createContext, useContext, useState } from 'react';

const NotificationContext = createContext();

export const NotificationProvider = ({ children }) => {
  const [unreadCounts, setUnreadCounts] = useState({}); // { conversationId: count }
  const [activeConversationId, setActiveConversationId] = useState(null);

  const addUnread = (conversationId) => {
    if (conversationId !== activeConversationId) {
      setUnreadCounts(prev => ({
        ...prev,
        [conversationId]: (prev[conversationId] || 0) + 1
      }));
    }
  };

  const markAsRead = (conversationId) => {
    setUnreadCounts(prev => {
      const newCounts = { ...prev };
      delete newCounts[conversationId];
      return newCounts;
    });
  };

  const clearAll = () => setUnreadCounts({});

  return (
    <NotificationContext.Provider value={{
      unreadCounts,
      activeConversationId,
      setActiveConversationId,
      addUnread,
      markAsRead,
      clearAll
    }}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotifications = () => useContext(NotificationContext);